import { reactive } from "vue";

// docs: https://vuejs.org/guide/scaling-up/state-management.html#simple-state-management-with-reactivity-api
// todo: make sure we need an API first. Lots of times, we can just access the data directly from the client.
export const cloudFunctions = reactive({
  continueChatApi: "https://continuechat-uply2xtwgq-uc.a.run.app",
  continueChatApiQa: "https://us-central1-articulearn-qa.cloudfunctions.net/continueChat",
  audioApi: "https://getaudio-uply2xtwgq-uc.a.run.app",
  audioApiQa: "https://us-central1-articulearn-qa.cloudfunctions.net/getAudio",
  lessonsApi: "https://lessonsapi-uply2xtwgq-uc.a.run.app",
  lessonsApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/lessonsApi",
  // The cloudfunctions.net form, not the gen2 Cloud Run URL the deploy mints:
  // that one is not known until dailyPlayApi has been deployed to PROD once,
  // and a placeholder would be answered by Hosting's catch-all rewrite with the
  // SPA shell, which reads as a successful call. This form resolves to the same
  // service in both projects and is correct from the first deploy.
  dailyPlayApi: "https://us-central1-spanishai.cloudfunctions.net/dailyPlayApi",
  dailyPlayApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/dailyPlayApi",
  stripeApi:
    "https://us-central1-spanishai.cloudfunctions.net/createCheckoutSession",
  stripeApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/createCheckoutSession",
  stripeBillingApi:
    "https://us-central1-spanishai.cloudfunctions.net/createBillingSession",
  stripeBillingApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/createBillingSession",
  iapValidateApi:
    "https://us-central1-spanishai.cloudfunctions.net/validateIapReceipt",
  iapValidateApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/validateIapReceipt",
  detectRegionApi:
    "https://us-central1-spanishai.cloudfunctions.net/detectRegion",
  detectRegionApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/detectRegion",
  adminApi: "https://us-central1-spanishai.cloudfunctions.net/adminApi",
  adminApiQa: "https://us-central1-articulearn-qa.cloudfunctions.net/adminApi",
  feedbackApi: "https://us-central1-spanishai.cloudfunctions.net/feedbackApi",
  feedbackApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/feedbackApi",
  manageLearningLanguageApi:
    "https://managelearninglanguage-uply2xtwgq-uc.a.run.app",
  manageLearningLanguageApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/manageLearningLanguage",
  deleteAccountApi:
    "https://us-central1-spanishai.cloudfunctions.net/deleteAccount",
  deleteAccountApiQa:
    "https://us-central1-articulearn-qa.cloudfunctions.net/deleteAccount",
  getContinueChatApi() {
    if (isLocalhost()) {
      console.log("hitting local getContinueChatApi");
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/continueChat`;
    } else if (isProd()) {
      return this.continueChatApi;
    }
    return this.continueChatApiQa;
  },
  getAudioApi() {
    if (isLocalhost()) {
      console.log("hitting local getAudioApi");
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/getAudio`;
    } else if (isProd()) {
      return this.audioApi;
    }
    return this.audioApiQa;
  },
  getLessonsApi() {
    if (isLocalhost()) {
      console.log("hitting local getLessonsApi");
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/lessonsApi`;
    } else if (isProd()) {
      return this.lessonsApi;
    }
    return this.lessonsApiQa;
  },
  getDailyPlayApi() {
    if (isLocalhost()) {
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/dailyPlayApi`;
    } else if (isProd()) {
      return this.dailyPlayApi;
    }
    return this.dailyPlayApiQa;
  },
  getManageLearningLanguageApi() {
    if (isLocalhost()) {
      console.log("hitting local getManageLearningLanguageApi");
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/manageLearningLanguage`;
    } else if (isProd()) {
      return this.manageLearningLanguageApi;
    }
    return this.manageLearningLanguageApiQa;
  },
  getDeleteAccountApi() {
    if (isLocalhost()) {
      console.log("hitting local getDeleteAccountApi");
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/deleteAccount`;
    } else if (isProd()) {
      return this.deleteAccountApi;
    }
    return this.deleteAccountApiQa;
  },
  getStripeCheckoutApi() {
    if (isLocalhost()) {
      console.log("hitting local getStripeApi");
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/createCheckoutSession`;
    } else if (isProd()) {
      return this.stripeApi;
    }
    return this.stripeApiQa;
  },
  getStripeBillingApi() {
    if (isLocalhost()) {
      console.log("hitting local getStripeBillingApi");
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/createBillingSession`;
    } else if (isProd()) {
      return this.stripeBillingApi;
    }
    return this.stripeBillingApiQa;
  },
  getIapValidateApi() {
    if (isLocalhost()) {
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/validateIapReceipt`;
    } else if (isProd()) {
      return this.iapValidateApi;
    }
    return this.iapValidateApiQa;
  },
  getDetectRegionApi() {
    if (isLocalhost()) {
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/detectRegion`;
    } else if (isProd()) {
      return this.detectRegionApi;
    }
    return this.detectRegionApiQa;
  },
  getAdminApi() {
    if (isLocalhost()) {
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/adminApi`;
    } else if (isProd()) {
      return this.adminApi;
    }
    return this.adminApiQa;
  },
  getFeedbackApi() {
    if (isLocalhost()) {
      return `http://${getLocalEmulatorHost()}:5001/articulearn-qa/us-central1/feedbackApi`;
    } else if (isProd()) {
      return this.feedbackApi;
    }
    return this.feedbackApiQa;
  },
});

function isLocalhost() {
  // Hostname-based on purpose: the local dev server and emulator aren't deploy
  // environments, so VUE_APP_FIREBASE_ENV (which isProd() uses) isn't the right
  // signal here. Capacitor short-circuits because its WebView hostname is also
  // "localhost" but the bundle is a deployed build, not a dev server.
  if (typeof window !== "undefined" && window.Capacitor?.isNativePlatform?.() === true) return false;
  return location.hostname === "localhost" || location.hostname === "127.0.0.1";
}

function getLocalEmulatorHost() {
  // Android emulator uses 10.0.2.2 to reach host machine; web uses localhost
  if (typeof window !== "undefined" && window.Capacitor?.isNativePlatform?.() === true) return "10.0.2.2";
  return "localhost";
}

// Exported for consumers that need env-aware external links (e.g. the admin
// Stripe dashboard link) to agree with the Firebase project we call.
export function isProd() {
  // Stay in lockstep with firebase-config.js so the Firebase project we
  // initialize against and the Cloud Functions we call always agree.
  const env = process.env.VUE_APP_FIREBASE_ENV;
  return env === "prod" || env === "production";
}
